<ng-container *ngTemplateOutlet="idVerification">
</ng-container>

<ng-template #idVerification>
	<ng-container *ngIf="livelinessRequired else livelinessNotRequiredTemplate">
		<ng-container *ngTemplateOutlet="livelinessRequiredTemplate"></ng-container>
	</ng-container>
</ng-template>

<ng-container *ngIf="isModal">
	<app-mobile-kamona-message-widget
		[title]="modalTitle"
		[iconType]="iconType"
		[btnText]="btnText"
		[btnType]="btnType"
		(emitCancel)="setModal(false)"
		[description]="modalDescription">
	</app-mobile-kamona-message-widget>
</ng-container>

<ng-container *ngIf="showSuccessModal">
	<app-mobile-kamona-message-widget
		title="Your Device was Registered Successfully!"
		[iconType]="IconType.SUCCESS"
		btnText="Goto Dashboard"
		[btnType]="BtnType.PRIMARY"
		(emitCancel)="goToDashboard()"
		description="Device Registration successful">
	</app-mobile-kamona-message-widget>
</ng-container>

<ng-template #livelinessNotRequiredTemplate>
		<app-mobile-kamona-otp-widget
			(emitBack)="goToLogin()"
			btnText="Next"
			[phoneNumber]="phoneNumber"
			[ussd]="ussdCode"
			headerTitle="Register Device"
			(emitReload)="goToLogin()"
			[hideBackBtn]="true"
			[useCustomMobileStepper]="true"
			[useHeaderBorder]="true"
			[submitting]="submitting"
			(emitSubmit)="handleOtpResponse($event)"
			[description]="description"
			title="Enter OTP">
		</app-mobile-kamona-otp-widget>
</ng-template>

<ng-template #livelinessRequiredTemplate>
	<ng-container>
		<app-mobile-kamona-liveliness-widget
			(emitCancel)="goToLogin()"
			[flowId]="flowId"
			[metaMapReference]="reference"
			[submitting]="submitting"
			[identityProvider]="provider"
			(emitFinishedMetamapVerification)="handleFinishedMetaMapVerification()"
			(emitFinishedSmileIDVerification)="submitSmileIDJob($event)">
		</app-mobile-kamona-liveliness-widget>
	</ng-container>
	<ng-container *ngIf="processVerification">
		<app-mobile-kamona-id-verification
			(emitVerifiedIdentity)="handleVerifiedIdentity($event)"
			(emitFailedIdentity)="handleFailedIdentity($event)"
			[verificationPayload]="verificationPayload"
			[verificationUrl]="idVerificationUrl">
		</app-mobile-kamona-id-verification>
	</ng-container>
</ng-template>
